<form #customFieldsForm="ngForm" class="small-labels" id="{{idString}}">
    <div class="row"
        *ngIf="webhookDefData && webhookDefData.custom_fields_refactored && isValidJson(webhookDefData.custom_fields_refactored)">
        <div class="mb-3" *ngFor="let field of webhookDefData.custom_fields_refactored; let i = index"
            [ngClass]="[columClass, (!allowedFields(field) ? 'wh-invalid-custom-fields' : '')]">
            <div *ngIf="allowedFields(field)">
                <label for="{{idString}}-custom_fields_{{i}}_{{field.fieldType}}" class="form-label"
                    style="text-transform: capitalize;">
                    {{field.fieldLabel ? field.fieldLabel : field.fieldName ? field.fieldName : ''}}
                </label>

                <input type="text" ngModel *ngIf="field.fieldType === 'text'" class="form-control form-control-sm"
                    [required]="field.requiredField" name="{{idString}}-custom_fields_{{i}}_text"
                    id="{{idString}}-custom_fields_{{i}}_text" [(ngModel)]="field.value">

                <textarea ngModel *ngIf="field.fieldType === 'textarea'" class="form-control form-control-sm"
                    [required]="field.requiredField" name="{{idString}}-custom_fields_{{i}}_textarea"
                    id="{{idString}}-custom_fields_{{i}}_textarea" [(ngModel)]="field.value"></textarea>

                <input type="password" ngModel *ngIf="field.fieldType === 'password'"
                    class="form-control form-control-sm" [required]="field.requiredField"
                    name="{{idString}}-custom_fields_{{i}}_password" id="{{idString}}-custom_fields_{{i}}_password"
                    [(ngModel)]="field.value">

                <input type="number" ngModel *ngIf="field.fieldType === 'number'" class="form-control form-control-sm"
                    [required]="field.requiredField" [pattern]="regExPatterns.regexPositiveInteger"
                    name="{{idString}}-custom_fields_{{i}}_number" id="{{idString}}-custom_fields_{{i}}_number"
                    [(ngModel)]="field.value" [defaultValue]="field.defaultValue" [minlength]="field.minValue">

                <input type="email" ngModel *ngIf="field.fieldType === 'email'" class="form-control form-control-sm"
                    [required]="field.requiredField" [pattern]="regExPatterns.email"
                    name="{{idString}}-custom_fields_{{i}}_email" id="{{idString}}-custom_fields_{{i}}_email"
                    [(ngModel)]="field.value">

                <input type="date" ngModel *ngIf="field.fieldType === 'date'" class="form-control form-control-sm"
                    [required]="field.requiredField" name="{{idString}}-custom_fields_{{i}}_date"
                    id="{{idString}}-custom_fields_{{i}}_date" [(ngModel)]="field.value">

                <select ngModel *ngIf="(field.fieldType === 'dropdown') || field?.fieldOptions?.values.length"
                    class="form-select form-select-sm" name="app_access_level" id="app_access_level" required
                    [required]="field.requiredField" name="{{idString}}-custom_fields_{{i}}_dropdown"
                    id="{{idString}}-custom_fields_{{i}}_dropdown" [(ngModel)]="field.value">
                    <option *ngFor="let item of field?.fieldOptions?.values">
                        {{item.option}}
                    </option>
                </select>

                <div *ngIf="customFieldsForm.form.controls[idString + '-custom_fields_' + i + '_' + field.fieldType]?.invalid && 
                (customFieldsForm.form.controls[idString + '-custom_fields_' + i + '_' + field.fieldType]?.dirty || customFieldsForm.form.controls[idString + '-custom_fields_' + i + '_' + field.fieldType]?.touched)"
                    class="invalid-feedback">
                    <div
                        *ngIf="customFieldsForm.form.controls[idString + '-custom_fields_' + i + '_' + field.fieldType]?.errors?.['required']">
                        {{errorMsgs.required}}
                    </div>
                    <div
                        *ngIf="customFieldsForm.form.controls[idString + '-custom_fields_' + i + '_' + field.fieldType]?.errors?.['pattern']">
                        {{errorMsgs.invalidFormat}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>